import { io } from 'socket.io-client'

export default defineNuxtPlugin(() => {
  const socket = io(getBaseUrl(), {
    extraHeaders: {
      authorization: useAppCookie('token').value || '',
      'app-code': getAppCode(),
    },
  })
  socket.on('reservation:invalidate', detail => window.dispatchEvent(new CustomEvent('reservation:invalidate', { detail })))
  return { provide: { reservationSocket: socket } }
})
